import { render, staticRenderFns } from "./TransactionItems.vue?vue&type=template&id=1197c9dd"
import script from "./TransactionItems.vue?vue&type=script&lang=ts"
export * from "./TransactionItems.vue?vue&type=script&lang=ts"
import style0 from "./TransactionItems.vue?vue&type=style&index=0&id=1197c9dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports